import { useCallback, useEffect, useState } from 'react';
import { useSession } from '@clerk/clerk-react';
import { toast } from 'react-toastify';
import { fetchWithAuth } from 'shared/api/fetch-with-auth';
import { API_URL } from 'constants/index';
import { AcquisitionStatistics } from '../types/statistics.types';

export const useAcquisitionStatistics = () => {
  const { session } = useSession();
  const [data, setData] = useState<AcquisitionStatistics | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  const fetchStats = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    try {
      const res = await fetchWithAuth(
        `${API_URL}/acquisitions/statistics`,
        {
          method: 'GET',
          headers: { 'Content-Type': 'application/json' },
        },
        session,
      );

      if (!res.ok) {
        throw new Error(
          `Failed to load acquisition statistics (status ${res.status})`,
        );
      }

      const stats = (await res.json()) as AcquisitionStatistics;
      setData(stats);
    } catch (e) {
      const err = e instanceof Error ? e : new Error(String(e));
      console.error('[useAcquisitionStatistics] error:', err);
      setError(err);
      toast.error('Kon acquisitie statistieken niet ophalen');
    } finally {
      setIsLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    fetchStats();
  }, [fetchStats]);

  return { data, isLoading, error, refresh: fetchStats };
};
